import LogoAndroid from "./LogoAndroid";
import LogoDocker from "./LogoDocker";
import LogoFigma from "./LogoFigma";
import LogoGoogleCloud from "./LogoGoogleCloud";
import LogoKeras from "./LogoKeras";
import LogoKubernetes from "./LogoKubernetes";
import LogoNode from "./LogoNode";
import LogoPython from "./LogoPython";
import LogoReact from "./LogoReact";
import LogoRedux from "./LogoRedux";
import LogoRuby from "./LogoRuby";
import LogoSass from "./LogoSass";
import LogoScikitLearn from "./LogoScikitLearn";

export {
    LogoAndroid,
    LogoDocker,
    LogoFigma,
    LogoGoogleCloud,
    LogoKeras,
    LogoKubernetes,
    LogoNode,
    LogoPython,
    LogoReact,
    LogoRedux,
    LogoRuby,
    LogoSass,
    LogoScikitLearn
};
